import { Spinner } from '@chakra-ui/react';

export const Loading = () => {
  return (
    <div
      style={{ height: '75vh' }}
      className="d-flex flex-row justify-content-center align-items-center"
    >
      <Spinner
        thickness="4px"
        speed="0.65s"
        emptyColor="gray.200"
        color="blue.500"
        size="xl"
      />
    </div>
  );
};
